import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CCheckboxLabelHtmlComponent } from './c-checkbox-label-html.component';
import { TrustHtmlModule } from 'src/app/pipes/trust-html/trust-html.module';
import { FetchImageFromHtmlModule } from 'src/app/pipes/fetch-image-from-html/fetch-image-from-html.module';
import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CCheckboxLabelHtmlComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    FetchImageFromHtmlModule,
    TrustHtmlModule,
    AsPipesModule,
  ],
  exports: [CCheckboxLabelHtmlComponent]
})
export class CCheckboxLabelHtmlModule { }
